import axios from 'axios'

import { orulTokenManager } from './orul-token-manager'

export const api = axios.create({
  baseURL: process.env.REACT_APP_TOTY_API_BASE_URL,
  timeout: 150000,
})

api.interceptors.request.use(async configs => {
  const accessToken = orulTokenManager.getToken()

  if (configs.headers && !!accessToken) {
    configs.headers.authorization = `Bearer ${accessToken}`
  }

  return configs
})

api.interceptors.response.use(configs => {
  if (configs.status === 401) {
    // setTimeout(() => {
    //   window.location.href = '/'
    // }, 100)
  }
  return configs
})
